import InsightsApi from 'api/InsightsApi';
import { useQueryHook } from 'utility/reactQueryHooks';

export const queryKeys = {
  getSubscriptionsListByMonth: (params) => ['getSubscriptionsListByMonth', JSON.stringify(params)],
};

export const useQueryGetSubscriptionsListByMonth = (params) =>
  useQueryHook(queryKeys.getSubscriptionsListByMonth(params), () => InsightsApi.getSubscriptionsListByMonth(params));
